import { Button, Modal, Popconfirm, Spin, Upload, message } from 'antd'
import { useRequest } from 'ahooks'
import { deleteZbControlNodeFileApi, getZbControlNodeFilesApi, uploadZbControlNodeFileApi } from '@/services/apis/controlNodesZb'
import { useState } from 'react'

export default function DDSFile({ projectID, nodeID, editable, onClose, onUpdate }: { projectID: string; nodeID: number; editable: boolean; onClose: () => void; onUpdate: () => void }) {
  const files = useRequest(() => getZbControlNodeFilesApi(projectID, nodeID))
  const [busy, setBusy] = useState(false)
  return <Modal open title="附件管理" onCancel={onClose} footer={<Button onClick={onClose}>关闭</Button>} maskClosable={false}>
    <Spin spinning={files.loading || busy}>
      {files.error ? <div role="alert">文件加载失败 <Button onClick={files.refresh}>重试</Button></div> : <div className="flex flex-col gap-3 py-3">
        {(files.data || []).map(f => <div key={f.id} className="flex justify-between gap-4"><a href={f.ddsFilePath} target="_blank" rel="noreferrer">{f.filename}</a>{editable && <Popconfirm title="确认删除该文件吗？" onConfirm={async () => {
          setBusy(true)
          try { await deleteZbControlNodeFileApi(projectID, f.id); await files.refreshAsync(); onUpdate() } catch (e) { message.error(String(e)) } finally { setBusy(false) }
        }}><Button danger size="small">删除</Button></Popconfirm>}</div>)}
        {!files.data?.length && <span className="text-gray-400">暂无附件</span>}
      </div>}
      {editable && <Upload showUploadList={false} beforeUpload={async file => {
        setBusy(true)
        try { await uploadZbControlNodeFileApi(projectID, nodeID, file); await files.refreshAsync(); onUpdate() } catch (e) { message.error(String(e)) } finally { setBusy(false) }
        return false
      }}><Button disabled={busy}>上传文件</Button></Upload>}
    </Spin>
  </Modal>
}
